'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatDuration;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDuration(aspNetStyleDuration) {
    var duration = _moment2.default.duration(aspNetStyleDuration);

    var result = '';
    if (Math.floor(duration.days()) > 0) {
        result += Math.floor(duration.days()) + 'd ';
    }
    if (Math.floor(duration.hours()) > 0) {
        result += Math.floor(duration.hours()) + 'h ';
    }
    if (Math.floor(duration.minutes()) > 0) {
        result += Math.floor(duration.minutes()) + 'm';
    }

    return result;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatDuration.js
// module id = 665
// module chunks = 0